import http from '@/plugins/api'
import * as types from './types'
import { startLoading } from '@/plugins/loading'
import globals from '@/plugins/globals'
import store from '@/store'

export default {
  async setLookups({ commit, dispatch, state }, data) {
    let profile = store.getters['auth/profile']
    let showInactive = false
    if (data.showInactive !== undefined && data.showInactive !== null) {
      showInactive = data.showInactive
    }
    let _keys = data.keys.filter(k => !state.lookups[k])
    if (data.refresh === undefined || data.refresh === null) {
      data.refresh = false
    }
    if (_keys.length || data.refresh) {
      if (data.firm === undefined || data.firm === null) {
        data.firm = profile.firm
      }
      const r = await startLoading(dispatch, 'setLookups', () =>
        http.post('lookup/ByKeys', {
          keys: data.keys,
          firm: data.firm,
          showInactive: showInactive
        })
      )
      commit(types.SET_LOOKUPS, [data.keys, r.data, showInactive])
    }
  },
  async getLookupsByGroup({ commit, dispatch, state }, { className, group }) {
    const r = await startLoading(dispatch, 'getLookupsByGroup', () => http.get(`lookup/ByGroup?className=${className}&group=${group}`))
    commit(types.SET_GROUPS, r.data)
  },
  async getOnboardLookups({ commit, dispatch, state }) {
    let showInactive = false
    let keys = ['StateProvince', 'Country', 'TimeZone', 'Language']
    const r = await startLoading(dispatch, 'getOnboardLookups', () => http.get('lookup/onboardLookups'))
    commit(types.SET_LOOKUPS, [keys, r.data, showInactive])
  },
  async upsertLookup({ commit, dispatch, state }, lookup) {
    const r = await startLoading(dispatch, 'upsertLookup', () => http.post('lookup/Upsert', lookup))
    commit(types.UPSERT_LOOKUP, [lookup, r.data])
    return r
  },
  async deleteLookup({ commit, dispatch, state }, lookup) {
    let _lookup = Object.assign({}, lookup)
    _lookup.isActive = false
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/Delete', _lookup))
    if (r.data[0].Results === '') {
      commit(types.DELETE_LOOKUP, lookup)
    }
    return r
  },
  async upsertGroup({ commit, dispatch, state }, { id, name }) {
    let data = {
      id: id,
      text: name
    }
    const r = await startLoading(dispatch, 'deleteLookup', () => http.post('lookup/UpsertGroup', data))
    if (r.data === id) {
      commit(types.UPSERT_GROUP, data)
    }
    return r
  },
  async setCountries({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/Countries'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_COUNTRIES, _data)
  },
  async setTimeZones({ commit, dispatch }) {
    const r = await startLoading(dispatch, 'setTimeZones', () => http.get('lookup/TimeZones'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_TIMEZONES, _data)
  },
  async setStateProvinces({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setStateProvinces', () => http.get(`lookup/StateProvince?id=${id}`))
    let _data = globals.sortArray(r.data)
    commit(types.SET_STATE_PROVINCES, _data)
  },
  async setLanguages({ commit, dispatch }, id) {
    const r = await startLoading(dispatch, 'setLanguages', () => http.get('lookup/Languages'))
    let _data = globals.sortArray(r.data)
    commit(types.SET_LANGUAGES, _data)
  },
  async getCountryCode({ state }, id) {
    let code = null
    state.lookups['Country'].forEach(element => {
      if (parseInt(element.value) === parseInt(id)) {
        code = element.code
      }
    })
    return code
  },
  async getStateProvinceAbbr({ state }, id) {
    let abbr = null
    state.lookups['StateProvince'].forEach(element => {
      if (parseInt(element.value) === parseInt(id)) {
        abbr = element.name
      }
    })
    return abbr
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/lookups/actions.js